// extracted by mini-css-extract-plugin
export var actions = "_ml-5";
export var assistantBubble = "_ml-3";
export var assistantRow = "_ml-6";
export var bubble = "_ml-0";
export var humanAvatar = "_ml-4";
export var inlineToolCard = "_ml-1";
export var userBubble = "_ml-2";